export enum ReminderTypes {
    wizardStage = 'WS',
    stepAwaiting = 'SA',
    stepAssigned = 'SS',
    stepCompleted = 'SC',
    stageCompleted = 'STC',
    default = ''
}
